import { cn } from "@/libs/cn";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/shadcn/popover"
import { Icon } from "@iconify-icon/solid";
import { For, Show } from "solid-js";
import { Button } from "@/components/shadcn/button";
import { Badge } from "@/components/shadcn/badge";
import { TextFieldRoot, TextFieldLabel, TextField } from "@/components/shadcn/textfield";

export const ListSorting = (props) => {

  const changeSort = (column, direction) => {
    props.onChange(column, direction);
  }

  const text = () => {
    const column = props.options.find((option) => option.value === props.sorting.column);
    if (column) {
      return column.text;
    }

    return "Default";
  }

  const icon = () => {
    return "lucide:sort-" + props.sorting.direction;
  }

  const tooltip = () => {
    if (props.sorting.direction === "asc") {
      return "Ascending";
    }

    return "Descending";
  }

  return (
    <Popover>
      <PopoverTrigger as={(innerProps) => <Button variant={"outline"} tooltip={tooltip()}
        class={cn(
          "justify-start text-left font-normal px-3 py-0 my-0",
          "text-muted-foreground",
          "py-0 my-0 h-auto"
        )} {...innerProps} />}>
        <span class="border-r border-black/10 h-9 dark:border-white/5 pe-3 me-2 flex items-center gap-1">
          <Icon icon="tabler:arrows-sort" class="h-4 w-4 hidden" />
          <span class="">Sort By</span>
        </span>
        <Badge class="me-1" variant="outline">{text()}</Badge>
        <Icon icon={icon()} />
      </PopoverTrigger>
      <PopoverContent class="w-auto p-0" showCloseButton={false}>
        <div>
          <div class="flex items-center border-b border-black/10 dark:border-white/5">
            <TextFieldRoot class="space-y-0">
              <TextFieldLabel class="sr-only">Search sorting column</TextFieldLabel>
              <TextField class="placeholder:text-foreground-muted text-xs flex border-0 focus-visible:outline-none focus-visible:ring-0 focus:outline-none focus:ring-0 dark:bg-transparent h-8 w-full rounded-md bg-transparent shadow-none py-3 sm:text-xs outline-none disabled:cursor-not-allowed disabled:opacity-50" placeholder="Search column..." />
            </TextFieldRoot>
          </div>
          <div class="pb-1 px-2">
            <For each={props.options}>
              {(option) => (
                <div class="flex items-center px-1 py-1 justify-between">
                  <Show when={option.icon}>
                    <Icon icon={option.icon} class="me-1" />
                  </Show>
                  <span class="text-muted-foreground text-xs me-2">{option.text}</span>
                  <div class="inline-flex gap-1">
                    <Button variant="outline" class="h-6 w-4 items-center justify-center" onClick={() => { changeSort(option.value, 'asc') }}>
                      <Icon icon="lucide:sort-asc" />
                    </Button>
                    <Button variant="outline" class="h-6 w-4 items-center justify-center" onClick={() => { changeSort(option.value, 'desc') }}>
                      <Icon icon="lucide:sort-desc" />
                    </Button>
                  </div>
                </div>
              )}
            </For>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
